import type { RouteRecordRaw } from 'vue-router';
import {
  authRoutes,
  errorRoutes,
  productRoutes,
  dashboardRoutes,
  manageRoutes,
  settingRoutes,
  orderRoutes,
} from './routes/index';

const routes: RouteRecordRaw[] = [
  {
    ...dashboardRoutes,
    children: [
      ...(dashboardRoutes.children || []),
    ],
  },
  {
    ...productRoutes,
    children: [
      ...(productRoutes.children || []),
    ],
  },
  {
    ...manageRoutes,
    children: [
      ...(manageRoutes.children || []),
    ],
  },
  {
    ...settingRoutes,
    children: [
      ...(settingRoutes.children || []),
    ],
  },
  {
    ...orderRoutes,
    children: [
      ...(orderRoutes.children || []),
    ],
  },
  {
    ...authRoutes,
    children: [
      ...(authRoutes.children || []),
    ],
  },
  ...errorRoutes,
];

export default routes;
